














import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import { IPolicyCarrierProductInput } from '@/modules/Policy/interfaces/policy-form'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'

@Component({
  components: {
    AppTextSearch
  }
})
export default class PolicyFormCarrierProduct extends mixins(SearchCarrierProduct) {
  @Prop({ type: Object as () => IPolicyCarrierProductInput }) value!: IPolicyCarrierProductInput
  @Prop({ type: Object as () => CarrierProduct }) carrierProduct!: CarrierProduct

  get disable () {
    return !!this.carrierProduct
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
